import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instance22ozgv6vdnc2g as EmptyIterator_instance } from './CollectionsKt.mjs';
import {
  iterator3f5i676wpaa3g as iterator,
  SequenceScope1coiso86pqzq2 as SequenceScope,
} from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance23tt71mgnug0i as Companion_instance,
} from './AbstractList.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().n2(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.q1())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda_0(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.il_1 = this$0;
        super($box);
        this.gl_1 = this$0.ml_1;
        this.hl_1 = this$0.ll_1;
      }
      ni() {
        if (this.gl_1 === 0) {
          this.pi();
        } else {
          this.oi(this.il_1.jl_1[this.hl_1]);
          var tmp = this;
          var tmp0 = this.il_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp.hl_1 = (this.hl_1 + 1 | 0) % tmp0.kl_1 | 0;
          this.gl_1 = this.gl_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      static nl(buffer, filledSize) {
        var $this = this.ui();
        $this.jl_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.jl_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.jl_1.length;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        $this.kl_1 = $this.jl_1.length;
        $this.ll_1 = 0;
        $this.ml_1 = filledSize;
        return $this;
      }
      static ol(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.nl(tmp$ret$0, 0);
      }
      q2() {
        return this.ml_1;
      }
      r2(index) {
        Companion_instance.i7(index, this.ml_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.ll_1 + index | 0) % this.kl_1 | 0;
        return this.jl_1[tmp$ret$0];
      }
      pl() {
        return this.ml_1 === this.kl_1;
      }
      p1() {
        return new (RingBuffer$iterator$1())(this);
      }
      tj(array) {
        var tmp;
        if (array.length < this.ml_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.ml_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.ml_1;
        var widx = 0;
        var idx = this.ll_1;
        while (widx < size && idx < this.kl_1) {
          result[widx] = this.jl_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          result[widx] = this.jl_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_0 = terminateCollectionToArray(size, result);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      i8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.ml_1;
        var tmp$ret$0 = Array(size);
        return this.tj(tmp$ret$0);
      }
      toArray() {
        return this.i8();
      }
      ql(maxCapacity) {
        var newCapacity = coerceAtMost((this.kl_1 + (this.kl_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.ll_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.jl_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.tj(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().nl(newBuffer, this.ml_1);
      }
      rl(element) {
        if (this.pl()) {
          throw IllegalStateException().o('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.ll_1 + this.ml_1 | 0) % this.kl_1 | 0;
        this.jl_1[tmp$ret$0] = element;
        this.ml_1 = this.ml_1 + 1 | 0;
      }
      sl(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.ml_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.ml_1;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        if (n > 0) {
          var start = this.ll_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.kl_1 | 0;
          if (start > end) {
            fill(this.jl_1, null, start, this.kl_1);
            fill(this.jl_1, null, 0, end);
          } else {
            fill(this.jl_1, null, start, end);
          }
          this.ll_1 = end;
          this.ml_1 = this.ml_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
var windowedIterator$slambdaClass;
function windowedIterator$slambda() {
  if (windowedIterator$slambdaClass === VOID) {
    class $ {
      constructor($size, $step, $iterator, $reuseBuffer, $partialWindows) {
        this.tl_1 = $size;
        this.ul_1 = $step;
        this.vl_1 = $iterator;
        this.wl_1 = $reuseBuffer;
        this.xl_1 = $partialWindows;
      }
      *yl($this$iterator, $completion) {
        var bufferInitialCapacity = coerceAtMost(this.tl_1, 1024);
        var gap = this.ul_1 - this.tl_1 | 0;
        if (gap >= 0) {
          var buffer = ArrayList().h2(bufferInitialCapacity);
          var skip = 0;
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = this.vl_1;
          $l$loop: while (_iterator__ex2g4s.q1()) {
            var e = _iterator__ex2g4s.r1();
            if (skip > 0) {
              skip = skip - 1 | 0;
              continue $l$loop;
            }
            buffer.i2(e);
            if (buffer.q2() === this.tl_1) {
              yield* $this$iterator.nk(buffer, $completion);
              if (this.wl_1) {
                buffer.a5();
              } else
                buffer = ArrayList().h2(this.tl_1);
              skip = gap;
            }
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!buffer.n1()) {
            if (this.xl_1 || buffer.q2() === this.tl_1)
              yield* $this$iterator.nk(buffer, $completion);
          }
        } else {
          var buffer_0 = RingBuffer().ol(bufferInitialCapacity);
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = this.vl_1;
          $l$loop_0: while (_iterator__ex2g4s_0.q1()) {
            var e_0 = _iterator__ex2g4s_0.r1();
            buffer_0.rl(e_0);
            if (buffer_0.pl()) {
              if (buffer_0.ml_1 < this.tl_1) {
                buffer_0 = buffer_0.ql(this.tl_1);
                continue $l$loop_0;
              }
              yield* $this$iterator.nk(this.wl_1 ? buffer_0 : ArrayList().j2(buffer_0), $completion);
              buffer_0.sl(this.ul_1);
            }
          }
          if (this.xl_1) {
            while (buffer_0.ml_1 > this.ul_1) {
              yield* $this$iterator.nk(this.wl_1 ? buffer_0 : ArrayList().j2(buffer_0), $completion);
              buffer_0.sl(this.ul_1);
            }
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!buffer_0.n1())
              yield* $this$iterator.nk(buffer_0, $completion);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.yl(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    windowedIterator$slambdaClass = $;
  }
  return windowedIterator$slambdaClass;
}
function windowedIterator$slambda_0($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  var i = new (windowedIterator$slambda())($size, $step, $iterator, $reuseBuffer, $partialWindows);
  var l = ($this$iterator, $completion) => i.yl($this$iterator, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
